export default {
  auth: () => import("/home/runner/work/ralph-web/ralph-web/layouts/auth.vue").then(m => m.default || m),
  guest: () => import("/home/runner/work/ralph-web/ralph-web/layouts/guest.vue").then(m => m.default || m),
  public: () => import("/home/runner/work/ralph-web/ralph-web/layouts/public.vue").then(m => m.default || m)
}